import React from 'react';

const Loading = () => (
  <div className="loader" data-testid="loader" />
);

export default Loading;
